var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    {
      staticClass: "customer-card bg-white",
      class: { "no-margin": !_vm.margin, "customer-card--modal": _vm.inModal },
      attrs: { inline: _vm.inline }
    },
    [
      _c(
        "q-card-media",
        { staticClass: "customer-card__header" },
        [
          _c("q-icon", {
            staticClass: "customer-card__header__close cursor-pointer",
            attrs: { name: "close", color: "grey-11", size: "1.4em" },
            nativeOn: {
              click: function($event) {
                return _vm.handleClose($event)
              }
            }
          }),
          _c(
            "q-icon",
            {
              staticClass: "customer-card__header__dropdown",
              attrs: { name: "more_vert", color: "white", size: "1.5rem" }
            },
            [_c("customer-popover", { attrs: { customers: [_vm.customer] } })],
            1
          ),
          _c("img", {
            staticClass: "fit",
            attrs: { src: require("assets/img/banner.png") }
          }),
          _c(
            "q-card-title",
            {
              staticClass: "text-center",
              attrs: { slot: "overlay" },
              slot: "overlay"
            },
            [
              [
                _c("span", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.customerName) + "\n        "
                  )
                ])
              ]
            ],
            2
          )
        ],
        1
      ),
      _c(
        "q-card-main",
        { staticClass: "customer-card__content" },
        [
          _c(
            "q-tabs",
            {
              staticClass: "customer-card__tabs",
              attrs: { color: "white", "underline-color": "primary" }
            },
            [
              _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "general",
                  default: "",
                  label: _vm.$t("general"),
                  color: "black"
                },
                slot: "title"
              }),
              !_vm.isPerson
                ? _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "contact-person",
                      label: _vm.$tc("contact_person", 2),
                      color: "black"
                    },
                    slot: "title"
                  })
                : _vm._e(),
              _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "projects",
                  label: _vm.$tc("project", 2),
                  color: "black"
                },
                slot: "title"
              }),
              _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "invoices",
                  label: _vm.$tc("invoice", 2),
                  color: "black"
                },
                slot: "title"
              }),
              _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "quotes",
                  label: _vm.$tc("quote", 2),
                  color: "black"
                },
                slot: "title"
              }),
              _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "notes",
                  label: _vm.$tc("note", 2),
                  color: "black"
                },
                slot: "title"
              }),
              _c("general-tab", { attrs: { customer: _vm.customer } }),
              !_vm.isPerson
                ? _c("contact-person-tab", {
                    attrs: { customer: _vm.customer }
                  })
                : _vm._e(),
              _c("invoices-tab", { attrs: { customer: _vm.customer } }),
              _c("quotes-tab", { attrs: { customer: _vm.customer } }),
              _c("notes-tab", { attrs: { customer: _vm.customer } }),
              _c("projects-tab", { attrs: { customer: _vm.customer } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }